module.exports = __webpack_public_path__ + "img/logo-fnd.c414b74b.png";